import * as i0 from '@angular/core';
import { InjectionToken, Component, ChangeDetectionStrategy, Inject, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

/**
 * This is not a real service, but it looks like it from the outside.
 * It's just an InjectionTToken used to import the config object, provided from the outside
 */
const IconConfigService = new InjectionToken('IconConfig');

class IconComponent {
    /**
     *
     */
    constructor(config) {
        this.config = config;
        this.viewbox = '';
        this.baseUrl = '/assets/';
        if (!config?.spritesheetUrl) {
            console.error('No spritesheet URL defined');
        }
        this.baseUrl = config.spritesheetUrl;
    }
    ngOnInit() {
        // warn user when icon is not properly set
        if (!this.anchor) {
            console.warn('icon anchor is required');
        }
    }
}
IconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.3", ngImport: i0, type: IconComponent, deps: [{ token: IconConfigService }], target: i0.ɵɵFactoryTarget.Component });
IconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.3", type: IconComponent, selector: "fstr-icon", inputs: { anchor: "anchor", title: "title", viewbox: "viewbox" }, ngImport: i0, template: `
    <svg
      class="icon"
      [attr.viewbox]="viewbox"
      [ngClass]="['is--' + anchor]"
      aria-hidden="true"
    >
      <title>{{ title || anchor }}</title>
      <use [attr.xlink:href]="baseUrl + '#' + anchor"></use>
    </svg>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.3", ngImport: i0, type: IconComponent, decorators: [{
            type: Component,
            args: [{
                    // tslint:disable-next-line: component-selector
                    selector: 'fstr-icon',
                    template: `
    <svg
      class="icon"
      [attr.viewbox]="viewbox"
      [ngClass]="['is--' + anchor]"
      aria-hidden="true"
    >
      <title>{{ title || anchor }}</title>
      <use [attr.xlink:href]="baseUrl + '#' + anchor"></use>
    </svg>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [IconConfigService]
                }] }]; }, propDecorators: { anchor: [{
                type: Input
            }], title: [{
                type: Input
            }], viewbox: [{
                type: Input
            }] } });

class IconModule {
    static forRoot(config) {
        const cfg = {
            spritesheetUrl: '/assets/dist/svg/symbol/svg/sprite.symbol.svg',
            ...config,
        };
        return {
            ngModule: IconModule,
            providers: [
                {
                    provide: IconConfigService,
                    useValue: cfg,
                },
            ],
        };
    }
}
IconModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.3", ngImport: i0, type: IconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IconModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.3", ngImport: i0, type: IconModule, declarations: [IconComponent], imports: [CommonModule], exports: [IconComponent] });
IconModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.3", ngImport: i0, type: IconModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.3", ngImport: i0, type: IconModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [IconComponent],
                    exports: [IconComponent],
                    imports: [CommonModule],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { IconComponent, IconConfigService, IconModule };
